/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpgradeOptionDTO } from './upgradeOptionDTO';


/**
 * Resposta com opções de upgrade disponíveis para um plano de acesso
 */
export interface UpgradeOptionsResponseDTO { 
    /**
     * ID do plano atual
     */
    currentPlanId?: number;
    /**
     * Nome do plano atual
     */
    currentPlanName?: string;
    /**
     * Tipo do pacote do plano atual
     */
    currentPackageType?: UpgradeOptionsResponseDTO.CurrentPackageTypeEnum;
    /**
     * Valor mensal do plano atual
     */
    currentPlanValue?: number;
    /**
     * Categoria do plano atual
     */
    category?: UpgradeOptionsResponseDTO.CategoryEnum;
    /**
     * Lista de opções de upgrade disponíveis
     */
    availableUpgrades?: Array<UpgradeOptionDTO>;
    /**
     * Indica se há pagador externo
     */
    hasExternalPayer?: boolean;
    inTrialPeriod?: boolean;
}
export namespace UpgradeOptionsResponseDTO {
    export type CurrentPackageTypeEnum = 'SUBSCRIPTION_PROVIDER_PF_FREE' | 'SUBSCRIPTION_PROVIDER_PF_BASIC' | 'SUBSCRIPTION_LAB_FREE' | 'SUBSCRIPTION_LAB_BASIC' | 'SUBSCRIPTION_PROVIDER_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_PJ_2' | 'SUBSCRIPTION_PROVIDER_PJ_6' | 'SUBSCRIPTION_PROVIDER_PJ_10' | 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_CONTRACTOR_PJ_120' | 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_ADMINISTRATOR';
    export const CurrentPackageTypeEnum = {
        ProviderPfFree: 'SUBSCRIPTION_PROVIDER_PF_FREE' as CurrentPackageTypeEnum,
        ProviderPfBasic: 'SUBSCRIPTION_PROVIDER_PF_BASIC' as CurrentPackageTypeEnum,
        LabFree: 'SUBSCRIPTION_LAB_FREE' as CurrentPackageTypeEnum,
        LabBasic: 'SUBSCRIPTION_LAB_BASIC' as CurrentPackageTypeEnum,
        ProviderPjFree: 'SUBSCRIPTION_PROVIDER_PJ_FREE' as CurrentPackageTypeEnum,
        ProviderPj2: 'SUBSCRIPTION_PROVIDER_PJ_2' as CurrentPackageTypeEnum,
        ProviderPj6: 'SUBSCRIPTION_PROVIDER_PJ_6' as CurrentPackageTypeEnum,
        ProviderPj10: 'SUBSCRIPTION_PROVIDER_PJ_10' as CurrentPackageTypeEnum,
        ProviderPjPersonal: 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' as CurrentPackageTypeEnum,
        ProviderContractorPjFree: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' as CurrentPackageTypeEnum,
        ProviderContractorPj100: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' as CurrentPackageTypeEnum,
        ProviderContractorPjPersonal: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' as CurrentPackageTypeEnum,
        ContractorPj120: 'SUBSCRIPTION_CONTRACTOR_PJ_120' as CurrentPackageTypeEnum,
        ContractorPjPersonal: 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' as CurrentPackageTypeEnum,
        Administrator: 'SUBSCRIPTION_ADMINISTRATOR' as CurrentPackageTypeEnum
    };
    export type CategoryEnum = 'PESSOA_FISICA' | 'LABORATORIO' | 'PRESTADOR_PJ' | 'HIBRIDO_PRESTADOR_CONTRATANTE' | 'CONTRATANTE_PJ' | 'ADMINISTRADOR';
    export const CategoryEnum = {
        PessoaFisica: 'PESSOA_FISICA' as CategoryEnum,
        Laboratorio: 'LABORATORIO' as CategoryEnum,
        PrestadorPj: 'PRESTADOR_PJ' as CategoryEnum,
        HibridoPrestadorContratante: 'HIBRIDO_PRESTADOR_CONTRATANTE' as CategoryEnum,
        ContratantePj: 'CONTRATANTE_PJ' as CategoryEnum,
        Administrador: 'ADMINISTRADOR' as CategoryEnum
    };
}


